import React from 'react';
import Button from '../components/Button';
import CallOut from '../components/CallOut';
import { UIActions } from '../ui/uiSlice';
import provisionRegisterUrl from '../utils/url/provisionRegisterUrl';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';

const PROVISION_FRAGMENT = gql(`
  fragment SignUpLinkTip_provision on Provision {
    ...provisionRegisterUrl_provision
  }
`);

interface SignUpLinkTipProps {
  provision: DocumentType<typeof PROVISION_FRAGMENT>;
}

const SignUpLinkTip = ({ provision }: SignUpLinkTipProps) => {
  const dispatch = useAppDispatch();
  const url = provisionRegisterUrl(provision);

  if (!url) {
    return null;
  }

  return (
    <CallOut variant="warning">
      <strong>Tip:</strong> You can also share a signup link to this provision.{' '}
      <Button
        variant="link"
        onClick={async () => {
          await navigator.clipboard.writeText(url);
          dispatch(
            UIActions.pushToast({
              level: 'success',
              message: 'Signup link copied',
            }),
          );
        }}
      >
        Copy link
      </Button>
    </CallOut>
  );
};

export default SignUpLinkTip;
